import { VerificationFailedContainer } from 'src/containers';

export const VerificationFailed = () => <VerificationFailedContainer />;
